import { render, staticRenderFns } from "./KanbanColumn.vue?vue&type=template&id=65f8726a&scoped=true&"
import script from "./KanbanColumn.vue?vue&type=script&lang=js&"
export * from "./KanbanColumn.vue?vue&type=script&lang=js&"
import style0 from "./KanbanColumn.vue?vue&type=style&index=0&id=65f8726a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f8726a",
  null
  
)

export default component.exports